module.exports = __webpack_public_path__ + "img/logomid.0fbe0ec2.png";